var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangesRequested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.917,
    cy: 21.5,
    r: 21.5,
    fill: "#FFF0C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66406 21.5001C9.66406 14.7329 15.1494 9.24756 21.9166 9.24756C28.6837 9.24756 34.1691 14.7329 34.1691 21.5001C34.1691 28.2672 28.6837 33.7526 21.9166 33.7526C15.1494 33.7526 9.66406 28.2672 9.66406 21.5001ZM21.9166 16.7876C22.1665 16.7876 22.4063 16.8869 22.583 17.0636C22.7598 17.2404 22.8591 17.4801 22.8591 17.7301V22.4426C22.8591 22.6925 22.7598 22.9323 22.583 23.109C22.4063 23.2858 22.1665 23.3851 21.9166 23.3851C21.6666 23.3851 21.4269 23.2858 21.2501 23.109C21.0734 22.9323 20.9741 22.6925 20.9741 22.4426V17.7301C20.9741 17.4801 21.0734 17.2404 21.2501 17.0636C21.4269 16.8869 21.6666 16.7876 21.9166 16.7876ZM21.9166 27.1551C22.1665 27.1551 22.4063 27.0558 22.583 26.879C22.7598 26.7023 22.8591 26.4625 22.8591 26.2126C22.8591 25.9626 22.7598 25.7229 22.583 25.5461C22.4063 25.3694 22.1665 25.2701 21.9166 25.2701C21.6666 25.2701 21.4269 25.3694 21.2501 25.5461C21.0734 25.7229 20.9741 25.9626 20.9741 26.2126C20.9741 26.4625 21.0734 26.7023 21.2501 26.879C21.4269 27.0558 21.6666 27.1551 21.9166 27.1551Z",
    fill: "#FFB53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangesRequested);
export default __webpack_public_path__ + "static/media/changes-requested.96bd1513867133541ffef787607dd565.svg";
export { ForwardRef as ReactComponent };